// extracted by mini-css-extract-plugin
export default {"wrap":"wrap---eI5QF","centered":"centered---_0nWH","submitButton":"submitButton---Uo5OM"};